<template>
  <div class="bg-[#00554A] h-screen relative !after:hidden">
    <div class="sticky top-0 z-10">
      <van-nav-bar class="custom-nav-bar " :border="false">
        <template #left>
          <Button @click="onClickLeft" type="back" />
        </template>
        <template #title>
          <div class="nav-tabs" :class="{ 'single-tab': !auditAppShow }">
            <div class="tab-item mx-[5px]" :class="{ active: activeTab === 'withdrawals' }"
              @click="switchTab('withdrawals')">
              {{ $t('wallet.chargebackRecord.withdrawalsTab') }}
            </div>
            <!-- <div v-if="auditAppShow" class="tab-item mx-[5px]" :class="{ active: activeTab === 'audit' }" @click="switchTab('audit')">
              {{ $t('wallet.chargebackRecord.auditTab') }}
            </div> -->
          </div>
        </template>
      </van-nav-bar>
    </div>
    <div ref="scrollRef" class="w-full h-[calc(100%-56px)] overflow-y-auto">
      <!-- 提现记录内容 -->
      <div v-if="activeTab === 'withdrawals'" class="mt-[15px] mx-[20px]">
        <div class="bonus-table-header">
          <div class="date-select">
            <Border radius="4px" borderWidth="2px">
              <div class="date-btn w-full h-[32px] flex items-center justify-between"
                @click="showOptions = !showOptions">
                {{ dateOptions[selectedDate].label }}
                <span :class="['arrow', showOptions ? 'up' : 'down']"></span>
              </div>

            </Border>

            <div v-if="showOptions" class="date-options">
              <div class="date-options-grid">
                <button v-for="(item, idx) in dateOptions" :key="item.value"
                  :class="['option-btn', { active: idx === selectedDate }]" @click="selectDate(idx)">
                  {{ item.label }}
                </button>
              </div>
            </div>
          </div>
          <div class="bonus-value">
            {{ $t('wallet.chargebackRecord.totalWithdrawal') }} <span class="yellow">{{ numberFormat(totalAmount)
              }}</span>
          </div>
        </div>
      </div>

      <!-- 审计记录内容 -->
      <div v-if="activeTab === 'audit' && auditAppShow" class="mt-[15px] mx-[20px]">
        <div class="audit-header">
          <div class="audit-value">
            {{ $t('wallet.chargebackRecord.auditAmount') }} <span class="orange">{{ numberFormat(auditAmount) }}</span>
          </div>
          <div class="audit-filter">
            <Border radius="4px" borderWidth="2px">
              <div class="filter-btn w-full h-[32px] flex items-center justify-between"
                @click="showFilterOptions = !showFilterOptions">
                <div style="font-size: 16px;">{{ filterOptions[selectedFilter].label }}</div>
                <span :class="['arrow', showFilterOptions ? 'up' : 'down']"></span>
              </div>

            </Border>

            <div v-if="showFilterOptions" class="filter-options">
              <button v-for="(item, idx) in filterOptions" :key="item.value"
                :class="['filter-option-btn', { active: idx === selectedFilter }]" @click="selectFilter(idx)">
                {{ item.label }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 提现记录列表 -->
      <div v-if="activeTab === 'withdrawals'" class="deposit-list">
        <div v-if="withdrawalsData.length">
          <div v-for="item in withdrawalsData" :key="item.orderId" class="deposit-card">
            <div class="card-header">
              <div class="card-time">{{ formatDateTime(item.createTime) }}</div>
              <div class="amount"><span v-if="IS_DOUBLE_WALLET">{{ VITE_symbol }}</span> {{ numberFormat(item.amount) }}
              </div>
            </div>

            <div class="card-order">
              <span class="order-text">{{ formatOrderId(item.orderId) }}</span>
              <img :src="getAssetsFile('home/copy.png')" class="copy-icon" @click="copyOrder(item.orderId)" />
            </div>
            <div class="card-status" :class="getStatusInfo(item.status).class">
              {{ getStatusInfo(item.status).text }}
            </div>
          </div>
        </div>
        <div v-else>
          <div class="empty-wrap">
            <div class="flex justify-center items-center">
              <img :src="getAssetsFile('home/No_record@2x.png')" alt=""
                class="max-h-[84px] max-w-[106.5px] w-auto h-auto">
            </div>
            <div class="empty-text">{{ $t('wallet.chargebackRecord.noRecords') }}</div>
          </div>
        </div>
      </div>

      <!-- 审计记录列表 -->
      <div v-if="activeTab === 'audit' && auditAppShow" class="audit-list">
        <div v-if="auditData.length">
          <div v-for="item in auditData" :key="item.id" class="audit-card" @click="goToAuditDetail(item)">
            <div class="audit-card-header">
              <div class="audit-type">{{ getActivityName(item.type) }}</div>
              <div class="audit-amount">{{ VITE_symbol }} {{ numberFormat(item.unfinishedAmount) }}</div>
            </div>

            <div class="audit-info">
              <div class="audit-time">{{ formatDateTime(item.createTime) }}</div>
              <div class="audit-order">
                {{ item.orderNo }}
              </div>
            </div>

            <div class="audit-status" :class="getAuditStatusInfo(item.status).class">
              {{ getAuditStatusInfo(item.status).text }}
            </div>
          </div>
        </div>
        <div v-else>
          <div class="empty-wrap">
            <div class="flex justify-center items-center">
              <img :src="getAssetsFile('home/No_record@2x.png')" alt=""
                class="max-h-[84px] max-w-[106.5px] w-auto h-auto">
            </div>
            <div class="empty-text">{{ $t('wallet.chargebackRecord.noRecords') }}</div>
          </div>
        </div>
      </div>
    </div>


    <!-- 蒙层 -->
    <div v-if="showFilterOptions || showOptions" class="overlay" @click="closeAllDropdowns"></div>
  </div>
</template>

<script setup lang="ts">
import { Border } from "@/components/Border"
import { Button } from "@/components/Button"
import { useRouter } from 'vue-router'
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import dayjs from 'dayjs'
import * as GameApi from '@/api/game'
import { useClipboard } from '@vueuse/core'
import { getAssetsFile } from '@/utils/pub-use'
import { numberFormat } from '@/utils/formatter'
import { formatDateTime } from '@/utils/date'
const VITE_symbol = import.meta.env.VITE_SYMBOL
const IS_DOUBLE_WALLET = import.meta.env.VITE_IS_DOUBLE_WALLET
const { t } = useI18n()
const scrollRef = ref<HTMLElement | null>(null)
const router = useRouter()
const showOptions = ref(false)
const now = new Date()
const pageSize = ref(10)
const selectedDate = ref(0)

// 分别存储提现记录和审计记录数据
const withdrawalsData = ref([])
const auditData = ref([])

// 添加标签状态
const activeTab = ref('withdrawals') // 默认选中提现记录

// 添加审计记录相关状态
const showFilterOptions = ref(false)
const selectedFilter = ref(0)
const auditAmount = ref(0)
const auditAppShow = ref(false) // 审计选项显示开关，true=显示，false=隐藏

// 审计记录筛选选项 - 使用翻译
const filterOptions = computed(() => [
  { label: t('wallet.chargebackRecord.filter.all'), value: '' },
  { label: t('wallet.chargebackRecord.filter.memberDeposit'), value: '1' },
  { label: t('wallet.chargebackRecord.filter.events'), value: '2' },
  { label: t('wallet.chargebackRecord.filter.systemAudit'), value: '3' }
])

// 分别管理提现记录和审计记录的分页状态
const withdrawalsPageNo = ref(1)
const auditPageNo = ref(1)
const withdrawalsTotal = ref(0)
const auditTotal = ref(0)

// 修改获取提现数据的方法
const fetchData = async () => {
  try {
    const params = {
      pageNo: withdrawalsPageNo.value,
      pageSize: pageSize.value,
      startTime: dateOptions.value[selectedDate.value].value
    }
    const response = await GameApi.chargebackRecord(params)
    if (response.data) {
      if (withdrawalsPageNo.value === 1) {
        // 第一页，替换数据
        withdrawalsData.value = response.data.recordVOList || []
      } else {
        // 加载更多，追加数据
        withdrawalsData.value.push(...(response.data.recordVOList || []))
      }
      withdrawalsTotal.value = response.data.totalAmount || 0
    }
  } catch (error) {
    console.error('获取提现记录失败:', error)
  }
}

// 修改获取审计数据的方法
const fetchAuditData = async () => {
  const auditParams = {
    pageNo: auditPageNo.value,
    pageSize: pageSize.value,
    groupType: filterOptions.value[selectedFilter.value].value
  }

  const response = await GameApi.auditRecord(auditParams)
  console.log(response.data, 'hahahahahah')
  if (auditPageNo.value === 1) {
    // 第一页，替换数据
    auditData.value = response.data.pageResult.list || []
    // 只在第一页时赋值 auditAmount
    auditAmount.value = response.data.amount || 0
    // 添加总数保存
    auditTotal.value = response.data.pageResult.total || 0
  } else {
    // 加载更多，追加数据
    auditData.value.push(...(response.data.pageResult.list || []))
    // 分页请求时不再重新赋值 auditAmount
  }
}

// 修改切换标签函数，重置对应标签的分页
const switchTab = (tab: string) => {
  // 如果切换到 audit 但 auditAppShow 为 false，不允许切换
  if (tab === 'audit' && !auditAppShow.value) {
    return
  }
  activeTab.value = tab
  if (tab === 'withdrawals') {
    withdrawalsPageNo.value = 1 // 重置提现记录页码
    fetchData()
  } else if (tab === 'audit') {
    auditPageNo.value = 1 // 重置审计记录页码
    fetchAuditData()
  }
}

// 关闭所有下拉框
const closeAllDropdowns = () => {
  showFilterOptions.value = false
  showOptions.value = false
}

// 修改选择筛选选项函数
const selectFilter = (idx: number) => {
  selectedFilter.value = idx
  showFilterOptions.value = false
  auditPageNo.value = 1 // 重置审计记录页码
  fetchAuditData()
}

// 修改选择日期函数
const selectDate = (idx: number) => {
  selectedDate.value = idx
  showOptions.value = false
  withdrawalsPageNo.value = 1 // 重置提现记录页码
  fetchData()
}

const today = getStartOfDay(now)
const day3 = getStartOfDay(new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000)) // 3天前（含今天）
const day5 = getStartOfDay(new Date(now.getTime() - 4 * 24 * 60 * 60 * 1000)) // 5天前（含今天）
const day7 = getStartOfDay(new Date(now.getTime() - 6 * 24 * 60 * 60 * 1000)) // 7天前（含今天）

// 使用翻译的日期选项
const dateOptions = computed(() => [
  { label: t('wallet.chargebackRecord.today'), value: formatDate(today) },
  { label: t('wallet.chargebackRecord.last3Days'), value: formatDate(day3) },
  { label: t('wallet.chargebackRecord.last5Days'), value: formatDate(day5) },
  { label: t('wallet.chargebackRecord.last7Days'), value: formatDate(day7) }
])

// 格式化为 yyyy-MM-dd 00:00:00
function formatDate(date: Date) {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d} 00:00:00`
}

// 获取当天0点
function getStartOfDay(date = new Date()) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
}

const totalAmount = computed(() => {
  return withdrawalsData.value.reduce((sum, row) => {
    const n = Number(row.amount)
    return sum + (isNaN(n) ? 0 : n)
  }, 0)
})

const onClickLeft = () => {
  router.push('/wallet')
}

// 修复：将 useClipboard 移到顶层
const { copy: copyToClipboard } = useClipboard()

function copyOrder(orderNo: string) {
  // 修复：直接使用顶层的 copyToClipboard
  copyToClipboard(orderNo)
    ; (window as any).$toast(t('wallet.chargebackRecord.copySuccess'))
}

// 添加滚动监听
const handleScroll = () => {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  const windowHeight = window.innerHeight
  const documentHeight = document.documentElement.scrollHeight

  // 当滚动到距离底部100px时触发加载
  if (scrollTop + windowHeight >= documentHeight - 100) {
    loadNextPage()
  }
}

// 获取提现配置
const getWithdrawalConfiguration = async () => {
  try {
    const res = await GameApi.withdrawalConfiguration()
    // 保存审计选项显示开关状态
    if (res && res.data) {
      auditAppShow.value = res.data.auditAppShow || false
    }
  } catch (error) {
    console.error('Failed to get withdrawal configuration:', error)
    auditAppShow.value = false
  }
}

// 在组件挂载时添加滚动监听
onMounted(async () => {
  // 先获取配置
  await getWithdrawalConfiguration()

  // 检查URL参数，设置默认标签
  const urlParams = new URLSearchParams(window.location.search)
  const tabParam = urlParams.get('tab')
  if (tabParam === 'audit' && auditAppShow.value) {
    // 只有当 auditAppShow 为 true 时才允许切换到 audit tab
    activeTab.value = 'audit'
    fetchAuditData() // 直接获取审计数据
  } else {
    fetchData() // 默认获取提现数据
  }

  scrollRef.value?.addEventListener('scroll', handleScroll)
})

// 在组件卸载时移除滚动监听
onUnmounted(() => {
  scrollRef.value?.removeEventListener('scroll', handleScroll)
})

// 修改加载下一页的方法
const loadNextPage = async () => {
  if (activeTab.value === 'withdrawals') {
    // 提现记录分页加载
    if (withdrawalsData.value.length >= withdrawalsTotal.value) {
      return // 已经加载完所有数据
    }
    withdrawalsPageNo.value += 1
    await fetchData()
  } else if (activeTab.value === 'audit') {
    // 审计记录分页加载 - 添加总数判断
    if (auditData.value.length >= auditTotal.value) {
      return // 已经加载完所有数据
    }
    auditPageNo.value += 1
    await fetchAuditData()
  }
}

// 提现记录状态配置 - 根据后端状态更新
const statusMap = computed(() => ({
  0: { text: t('wallet.chargebackRecord.status.withdrawing'), class: 'pending' }, // 等待运营审核 - 提现中
  1: { text: t('wallet.chargebackRecord.status.withdrawing'), class: 'pending' }, // 等待财务审核 - 提现中
  2: { text: t('wallet.chargebackRecord.status.withdrawing'), class: 'pending' }, // 打款中 - 提现中
  3: { text: t('wallet.chargebackRecord.status.success'), class: 'success' },     // 打款成功 - 提现成功
  4: { text: t('wallet.chargebackRecord.status.failed'), class: 'fail' },         // 打款失败 - 提现失败
  5: { text: t('wallet.chargebackRecord.status.failed'), class: 'fail' },         // 运营拒绝 - 提现失败
  6: { text: t('wallet.chargebackRecord.status.failed'), class: 'fail' },         // 财务拒绝 - 提现失败
  7: { text: t('wallet.chargebackRecord.status.reversed'), class: 'fail' }        // 成功后被回退
}))

// 审计记录状态配置 - 使用翻译
const auditStatusMap = computed(() => ({
  0: { text: t('wallet.chargebackRecord.auditStatus.pending'), class: 'pending' },
  1: { text: t('wallet.chargebackRecord.auditStatus.processing'), class: 'processing' },
  2: { text: t('wallet.chargebackRecord.auditStatus.approved'), class: 'success' }
}))

// 获取提现状态信息
const getStatusInfo = (status: number) => {
  return statusMap.value[status] || { text: t('wallet.chargebackRecord.status.unknown'), class: 'timeout' }
}

// 获取审计状态信息
const getAuditStatusInfo = (status: number) => {
  return auditStatusMap.value[status] || { text: t('wallet.chargebackRecord.auditStatus.unknown'), class: 'timeout' }
}

// 获取活动名称的函数
const getActivityName = (activityId: number) => {
  return t(`wallet.chargebackRecord.activityNames.${activityId}`) || `Unknown Activity (${activityId})`
}

// 修改跳转到审计详情页面的方法 - 传递整个对象
const goToAuditDetail = (item: any) => {
  // 将整个审计对象编码后传递
  const encodedData = encodeURIComponent(JSON.stringify(item))
  router.push(`/wallet/auditDetail?data=${encodedData}`)
}

// 添加格式化订单号的函数
const formatOrderId = (orderId: string) => {
  if (!orderId) return ''
  // 如果订单号长度超过20个字符，显示前10个和后10个，中间用...连接
  if (orderId.length > 20) {
    return `${orderId.substring(0, 10)}...${orderId.substring(orderId.length - 10)}`
  }
  return orderId
}
</script>

<style lang="scss" scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.3), 0px -2px 22px 0px rgba(53, 189, 128, 0.61);

  &>* {
    height: 100%;
  }
}

/* 原有样式保持不变 */
.bonus-table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.date-select {
  position: relative;
  width: 160px;
}

.date-btn {
  // background: getPath('activity/historyDateSelectBorderBg.png') no-repeat;
  // background-size: 100% 100%;
  color: #fff;
  padding: 0 10px;
  display: flex;
  align-items: center;
}


.empty-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 115px 0 0 0;
}



.empty-text {
  color: #ADB1B0;
  font-size: 11px;
  margin-top: 21px;

}

.arrow {
  display: inline-block;
  margin-left: 6px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #40b665;
  transition: transform 0.2s;
}

.arrow.up {
  transform: rotate(180deg);
}

.arrow.down {
  transform: rotate(0deg);
}

.date-options {
  position: absolute;
  top: 45px;
  left: 0;
  background: #02523d;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  z-index: 10;
  padding: 16px 18px;
  min-width: 340px;
  width: max-content;
}

.date-options-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 16px;
}

.option-btn {
  background: transparent;
  color: #40b665;
  border-radius: 8px;
  padding: 12px 0;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  min-width: 120px;
  text-align: center;
  white-space: nowrap;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #006849;
}

.option-btn.active {
  background: #006849;
  color: #fff;
  border: 1px solid #40b665;
}

.bonus-value {
  width: 40%;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.bonus-value .yellow {
  color: #27D48B;
}

.bonus-table {
  margin-top: 24px;
}

/* 提现记录列表样式 */
.deposit-list {
  margin: 20px 20px 0 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.deposit-card {
  background: #003C31;
  border-radius: 10px;
  padding: 18px 16px 14px 16px;
  position: relative;
  cursor: pointer;
  margin-bottom: 20px;
  transition: background-color 0.2s;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
  color: #fff;
}

.type {
  font-size: 14px;
  font-weight: bold;
}

.card-header .amount {
  color: #ffffff;
  font-size: 16px;
}

.card-time {
  color: #34B388;
  font-size: 13px;
}

.card-order {
  color: #34B388;
  font-size: 13px;
  margin-top: 15px;
  display: flex;
  align-items: center;
}

.order-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.copy-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
  flex-shrink: 0;
  margin-left: 2px;
  /* 添加小的左边距 */
}

.card-status.success,
.card-status.fail,
.card-status.pending {
  color: #27D48B;
  font-size: 12px;
  position: absolute;
  right: 16px;
  bottom: 14px;
  white-space: nowrap;
  /* 防止状态文字换行，但不省略 */
}

.card-status.fail {
  color: #ff4d3b;
}

.card-status.pending {
  color: #FFA500;
}

/* 审计记录列表样式 */
.audit-list {
  margin: 20px 20px 0 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  overflow-y: auto;
}

.audit-card {
  background: #003C31;
  border-radius: 10px;
  padding: 18px 16px 14px 16px;
  position: relative;
  cursor: pointer;
  margin-bottom: 20px;
  transition: background-color 0.2s;
}

.audit-card:hover {
  background: linear-gradient(0deg, #18926B 0%, #299263 100%);
  box-shadow: 0px 2px 1px 0px rgba(0, 26, 26, 0.71), 0px 1px 0px 0px #5DC09B, 0px -1px 0px 0px #46B792;
  color: #fff;
  font-weight: bold;
}

.audit-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
  color: #fff;
}

.audit-type {
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
}

.audit-amount {
  min-width: 80px;
  text-align: right;
  color: #ffffff;
  font-size: 16px;
}

.audit-info {
  margin-top: 15px;
}

.audit-time {
  color: #34B388;
  font-size: 13px;
  margin-bottom: 8px;
}

.audit-order {
  color: #34B388;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.audit-status {
  font-size: 12px;
  position: absolute;
  right: 16px;
  bottom: 14px;
}

.audit-status.pending {
  color: #FFA500;
}

.audit-status.success {
  color: #27D48B;
}

.audit-status.fail {
  color: #ff4d3b;
}

.audit-status.processing {
  color: #4A90E2;
}

/* 重新设计导航栏样式 */
.nav-container {
  background: #02523d;
  padding: 0;
}

.nav-header {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  position: relative;
}

.back-icon {
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  margin-right: 20px;
  flex-shrink: 0;
}

.nav-tabs {
  display: flex;
  flex: 1;
  gap: 0;
  justify-content: center;
}

.nav-tabs.single-tab {
  justify-content: center;
}

.tab-item {
  flex: 1;
  text-align: center;
  color: #4FB388;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  padding: 10px 0;
}

.nav-tabs.single-tab .tab-item {
  flex: 0 0 auto;
  text-align: left;
  padding-left: 0;
}

.tab-item.active {
  color: #fff;
  font-weight: 500;
}

/** .tab-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 2px;
  background: #40b665;
  border-radius: 1px;
}
*/
.nav-tabs.single-tab .tab-item.active::after {
  display: none;
}

/* 审计记录头部样式 */
.audit-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.audit-value {
  color: #5a7a6b;
  font-size: 14px;
  font-weight: 500;
}

.audit-value .orange {
  color: #ffa500;
}

.audit-filter {
  position: relative;
  width: 130px;
}

.filter-btn {
  // background: getPath('activity/historyDateSelectBorderBg.png') no-repeat;
  // background-size: 100% 100%;
  color: #fff;
  padding: 0 10px;
  display: flex;
  align-items: center;
}

.filter-btn>div {
  flex: 1;
  text-align: left;
  word-wrap: break-word;
  word-break: break-word;
  line-height: 1.2;
  max-width: calc(100% - 24px);
  overflow: visible;
  white-space: normal;
}

.filter-options {
  position: absolute;
  top: 42px;
  left: 0;
  right: 0;
  background: #02523d;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  z-index: 10;
  width: 100%;
}

.filter-option-btn {
  background: #00563A;
  border: none;
  color: #34B388;
  border-radius: 0;
  padding: 12px 16px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  width: 100%;
  border-top: 1px solid #009F76;
  text-align: center;
  box-sizing: border-box;
}

.filter-option-btn:first-child {
  border-top: none;
}

.filter-option-btn.active {
  background: #1a6b4f;
  color: #fff;
}

/* 蒙层样式 */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 5;
}

/* 确保下拉框在蒙层之上 */
.filter-options,
.date-options {
  z-index: 10;
}
</style>

<route lang="json5">
  {
    name: 'chargebackRecord',
    meta: {
      title: 'Registro de Depósito',
      i18n: 'menus.chargebackRecord'
    },
  }
  </route>
